// extracted by mini-css-extract-plugin
export default {"setPresenceDuration":"SetPresenceDuration_setPresenceDuration__nXqoR","customDuratioin":"SetPresenceDuration_customDuratioin__ShQBl"};